import { Box, Button, Typography } from '@mui/material';
import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { Page } from '../../components/Page/Page';

export const NotFound = (): ReactElement => (
  <Page title='Slabstack'>
    <Box
      display='flex'
      flexDirection='column'
      gap='3rem'
      justifyContent='center'
      alignItems='center'
      gridArea='content'
    >
      <Typography variant='h3'>Page not found</Typography>
      <img
        src='/404.png'
        style={{
          width: '70%',
          height: 'auto',
        }}
        alt='404'
      />
      <Link to='/admin' style={{ textDecoration: 'none', color: 'inherit' }}>
        <Button variant='slab-primary' onClick={(): void => {}}>
          Return home
        </Button>
      </Link>
    </Box>
  </Page>
);
